import { render, staticRenderFns } from "./DispositionList.vue?vue&type=template&id=d47dc234"
import script from "./DispositionList.vue?vue&type=script&lang=js"
export * from "./DispositionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports